(function () {
    'use strict';

    angular.module('Directives').directive('bbaProfileManagerQuotes', bbaProfileManagerQuotes);

    bbaProfileManagerQuotes.$inject = [
        'BBAProfileManagerService',
        'CommonService',
        '$timeout',
        'usSpinnerService'
    ];

    function bbaProfileManagerQuotes(BBAProfileManagerService,
                                     CommonService,
                                     $timeout,
                                     usSpinnerService) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/bba-profile-manager/bba-profile-manager-quotes.html',
            scope: {
                step: '=',
                isViewMode: '=?',
                init: '=',
                onSelectCallback: '='
            },
            controller: bbaProfileManagerQuotesController,
            controllerAs: 'vm',
            bindToController: true
        };

        function bbaProfileManagerQuotesController($scope) {

            let vm = this;
            const {postcodesField, warehouseName} = vm.step;

            vm.toggleQuotes = toggleQuotes;
            vm.getMileServices = getMileServices;
            vm.selectService = selectService;

            $scope.$watch(angular.bind(this, () => this.init), value => {
                if (value) init();
            });

            function init() {
                vm.mileServices = [];
                vm.mileService = vm.step.details.serviceProfile || null;

                const warehouse = vm.step.details[warehouseName].location;
                vm.warehouseLocationId = warehouse && warehouse.id || null;
                vm.postcodes = vm.step.details[postcodesField + 's'].map(postcode => postcode.id);

                vm.showQuotes = false;

                vm.onSelectCallback();
                vm.showUpdateNotice = false;
                vm.fetchingQuotes = false;
                vm.fetchValue = 0;
                vm.fetchInterval = null;

                if (vm.mileService) {
                    vm.logoUrl = CommonService.isContainLogo(vm.mileService.carrierProfile);
                }
            }

            toggleQuotes(false);

            function toggleQuotes(value) {
                vm.showQuotes = value != null ? value : !vm.showQuotes;
                if (vm.showQuotes && !vm.mileServices.length) {
                    getMileServices();
                }
            }

            function getMileServices() {
                usSpinnerService.spin('mile-quote-spinner');
                const payload = {
                    [postcodesField + 'Ids']: vm.postcodes,
                    [warehouseName]: angular.copy(vm.step.details[warehouseName]),
                    packages: [vm.step.details['packages']]
                };

                const warehouse = payload[warehouseName];
                warehouse.location = warehouse.location && warehouse.location.id || null;

                vm.fetchingQuotes = true;
                BBAProfileManagerService.getQuote(payload, data => {
                    vm.mileServices = data.map(service => {
                        service.logoUrl = CommonService.isContainLogo(service.carrierProfile);
                        return service;
                    });
                    vm.fetchingQuotes = false;
                }, error => {
                    console.log(error);
                    vm.fetchingQuotes = false;
                }, vm.step.viewName.replace('MileCarrier', '-mile'))
            }

            function selectService(service) {
                vm.mileService = service;
                vm.step.details.serviceProfile = vm.mileService;
                vm.step.isValid = true;
                vm.logoUrl = service.logoUrl;
                vm.showUpdateNotice = false;
                vm.showQuotes = false;
                
                vm.onSelectCallback();
            }

            $scope.$watch(angular.bind(vm, () => {
                return this.step.details[postcodesField + 's'];
            }), value => {
                const postcodes = value.map(postcode => postcode.id);
                if (vm.init && JSON.stringify(vm.postcodes) !== JSON.stringify(postcodes)) {
                    clearService();
                }
                vm.postcodes = postcodes;
            });
            $scope.$watch(angular.bind(vm, () => {
                return this.step.details[warehouseName].location;
            }), value => {
                const warehouseLocationId = value && value.id || null;
                if (vm.init && vm.warehouseLocationId !== warehouseLocationId) {
                    clearService();
                }
                vm.warehouseLocationId = warehouseLocationId;
            });

            function clearService() {
                if (vm.mileService) {
                    vm.showUpdateNotice = true;
                }
                vm.mileServices = [];
                vm.mileService = vm.step.details.serviceProfile = null;
                vm.showQuotes = false;
            }

        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaProfileManagerQuotes.js